// extracted by mini-css-extract-plugin
export default {"card":"styles_card__WXoFO","active":"styles_active__9txxQ"};